import {External, M} from "../../external";

function getCookieValue(name) {
  if (!document || !document.cookie) {
    return '';
  }
  const parts = document.cookie.split(';');
  for (let i = 0; i < parts.length; i++) {
    const item = (parts[i] || '').trim();
    if (item.indexOf(name + '=') === 0) {
      return decodeURIComponent(item.substring(name.length + 1));
    }
  }
  return '';
}

function getLmsLocale() {
  let locale = '';
  if (window.location && window.location.search) {
    const match = window.location.search.match(/[?&]locale=([^&#]+)/);
    if (match && match[1]) {
      locale = decodeURIComponent(match[1]);
    }
  }
  if (!locale) {
    locale = getCookieValue('current-locale');
  }
  if (!locale && External && External.Website) {
    locale = External.Website.currentEditLocale || External.Website.defaultEditLocale || '';
  }
  if (!locale && External && External.WebsiteSettings && External.WebsiteSettings.getSettings) {
    const settings = External.WebsiteSettings.getSettings() || {};
    locale = settings.locale || '';
  }
  return (locale || '').toString().trim();
}

export async function makeLmsRequest(endpoint, method, requestBody, headers, options) {
  method = method || 'GET';
  options = options || {};
  const includeLocale = options.includeLocale !== false;
  const locale = getLmsLocale();
  let url = WebPlatform.lmsServiceApiDomain + endpoint;
  if (includeLocale && locale) {
    url += (url.indexOf('?') > -1 ? '&' : '?') + 'locale=' + encodeURIComponent(locale);
  }

  let defaultRequestHeaders = {
    'Content-Type': 'application/json',
    'X-Website-Hash': External.Website.hash,
    'X-Website-Details': External.WebPlatform.hash,
    'X-Active-Locale': includeLocale ? locale : '',
    // 'Access-Control-Allow-Origin': '*'
  };

  let requestHeaders;
  if (headers) {
    requestHeaders = Object.assign(defaultRequestHeaders, headers);
  } else {
    requestHeaders = defaultRequestHeaders;
  }

  let init = {
    method: method,
    headers: requestHeaders,
    // mode: 'no-cors',
  };

  if (requestBody) {
    let finalBody = requestBody;
    if (includeLocale && locale && typeof requestBody === 'object' && !Array.isArray(requestBody) && !requestBody.locale) {
      finalBody = {
        ...requestBody,
        locale
      };
    }
    init['body'] = JSON.stringify(finalBody);
  }

  let response = await fetch(url, init);
  if (!response.ok) {
    let error;
    try {
      error = await response.json();
    } catch(e) {
      error = await response.text();
    }
    let message = error.message || error;
    response.error = message;
    if (message !== 'LIMITED') {
      External.Tools.showError(M[message] || message);
    }
  }
  return response;
}

